const LAST_RELOAD_KEY = 'preloadErrorReloadAt';

/**
 * A chunk that still fails right after a reload is a real outage (or the user is
 * offline): surface the error instead of looping.
 */
const RELOAD_COOLDOWN_MS = 10_000;

/**
 * Reloads the page once when Vite fails to load a lazy chunk. This recovers clients
 * running a build whose chunks are no longer served (tab opened before a deploy) and
 * transient network failures while fetching a chunk.
 */
export function registerPreloadErrorReload(
	reload: () => void = () => window.location.reload(),
): () => void {
	const onPreloadError = () => {
		const now = Date.now();
		try {
			const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
			if (lastReload && now - lastReload < RELOAD_COOLDOWN_MS) {
				return;
			}
			sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
		} catch {
			return;
		}
		reload();
	};

	window.addEventListener('vite:preloadError', onPreloadError);
	return () => window.removeEventListener('vite:preloadError', onPreloadError);
}
